import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The FichaTradedProducts component.
 */
const FichaTradedProducts = () => (
  <GridContainer padding="0 0 8px">
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-RubrosyProductos.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Selecciona el año que deseas consultar.</Item>
        <Item>Selecciona el tipo de vista que deseas para los datos, ya sea visualización o tabla de datos.</Item>
        <Item>Corresponde a la categoría consultada.</Item>
        <Item>
          “Treemap” que muestra la distrubución de forma jerárquica por monto transado en cada una de las categorías.
        </Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default FichaTradedProducts
